"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importWithWebpack = void 0;

var loadScript_1 = require("./loadScript");

var loadWithWebpack_1 = require("./loadWithWebpack");
/**
 * Import a remote module and initialize with
 * Webpack's module sharing
 */


var importWithWebpack = function importWithWebpack(_a) {
  var url = _a.url,
      scope = _a.scope,
      _b = _a.module,
      module = _b === void 0 ? './Index' : _b;
  return (0, loadScript_1.loadScript)(url).then(function () {
    return (0, loadWithWebpack_1.loadWithWebpack)(scope, module);
  });
};

exports.importWithWebpack = importWithWebpack;